import React, { createContext, useState, useEffect, useMemo } from "react";
import { handleSessionExpired } from "../Core/SessionExpiredPopup";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // read from localStorage on init
    return localStorage.getItem("login") === "true";
  });

  useEffect(() => {
    localStorage.setItem("login", isAuthenticated);
  }, [isAuthenticated]);

   useEffect(() => {
    const handleUnauthorized = () => {
      // setIsAuthenticated(false);
      handleSessionExpired(); // 👈 show popup and redirect
    };

    window.addEventListener("unauthorized", handleUnauthorized);
    return () => {
      window.removeEventListener("unauthorized", handleUnauthorized);
    };
  }, []);

  const value = useMemo(
    () => ({ isAuthenticated, setIsAuthenticated }),
    [isAuthenticated]
  );

  return (
    <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
  );
};

export default AuthContext;
